<template lang="pug">
  div
    slot(name='children'
        v-bind:genericParentContainer='innerContainer',
        v-bind:parentContainer='outerContainer')

    slot(v-if='rendered',name='holder',
        v-bind:holder='holder',
        v-bind:transform='transform',
        v-bind:depth='depth',
        v-bind:innerContainer='innerContainer',
        v-bind:outerContainer='outerContainer',
        v-bind:displayObject='outerContainer')

    // this flashes at the moment every time you pan or zoom :-(
    //cache-as-bitmap(v-if='!context.noCacheAsBitmap && lol',
                    :container='outerContainer',
                    :render-tools='renderTools')
</template>
<script>
import CacheAsBitmap from './CacheAsBitmap.vue';
import EventEmitter from 'eventemitter3';
import {makeShape,measureStyledText,makeStyledText,makeTextBackground,makeBoundedBackground,makeFittedText,TEXT_UPSCALE} from '@/play/game/util.js';
import {debounce,throttle,cloneDeep} from 'lodash';
export default {
  props:{
    transform: {
      type: Object,
      required: true
    },
    innerContainer: {
      type: Object,
      required: true
    },
    outerContainer: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    holder: {
      type: Object,
      required: true
    },
    context: {
      type: Object,
      required: true
    }
  },
  components:{
    CacheAsBitmap
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    const text = new TextTransform(this.renderTools, this.innerContainer, this.transform, component);
    const throttledUpdate = debounce(this._throttledUpdate.bind(this), 300);
    return {
      text,
      component,
      rendered: false,
      lol :false,
      throttledUpdate
    }
  },
  mounted() {
    this.text.events.on("loaded", () => {
      this.rendered = true;
      this.$emit("loaded");
      this.renderTools.addToRunBatch( () => {
        this.lol = true;
      });
    });
    this.renderTools.addToEnterBatch(this.text);
    this.renderTools.addToUpdateBatch(this.text);
    this.holder.events().on('drag-start', () => {
      this.lol = false;
    });
    this.holder.events().on('drag-end', () => {
      this.lol = true;
    });
    this.renderTools.addToRunBatch( () => {
      this.holder.addSceneObject(this.component.id, this.text);
    });
  },
  beforeDestroy() {
    this.text.events.off("loaded");
    this.holder.events().off('drag-start');
    this.holder.events().off('drag-end');
    this.holder.removeSceneObject(this.component.id, this.text);
  },
  methods:{
    _throttledUpdate() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    }
  },
  watch:{
    'component.align'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.v'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.size'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.bounded'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.dropShadow'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.text'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.color'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.font'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.bg'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.bgcolor'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.bgx'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'component.bgy'() {
      this.renderTools.addToUpdateBatch(this.text, this.transform.id);
    },
    'transform.transform.scale.x'() {
      if (this.component.bounded) {
        this.throttledUpdate();
      }
    },
    'transform.transform.scale.y'() {
      if (this.component.bounded) {
        this.throttledUpdate();
      }
    }
  }
}
function TextTransform(renderTools, parentContainer, transform, data) {
  this.parentContainer = parentContainer;
  this.renderTools = renderTools;
  this.transform = transform;
  this.alpha = 1;
  this.events = new EventEmitter();
  this.data = data;
  this.themes = {};
  this.loading = true;
}
TextTransform.prototype.enter = function () {
  //this.text = makeStyledText(this.themes, this.data.text, this.data);
  //this.textContainer.addChild(this.text);
  //this.text.anchor.x = 0.5;
  //this.text.anchor.y = 0.5;
  //this.text.scale.x = 40;
  //this.text.scale.y = 40;

  if (!this.data.bg) {
    this.invisibleDummy = new PIXI.Graphics();
    this.invisibleDummy.scale.x = 1/35;
    this.invisibleDummy.scale.y = 1/35;
    makeBoundedBackground(this.data, this.transform.transform.scale, this.invisibleDummy, this.renderTools);
    this.invisibleDummy.alpha = 0.0;
    this.parentContainer.addChild(this.invisibleDummy);
    this.prevBackgroundColor = this.data.bgcolor;
  }


}

TextTransform.prototype.setupBackground = function () {
  if (!this.data.bounded) {
    const shapeData = makeTextBackground(
      this.data.text,
      this.textOptions,
      this.renderTools.convertWidthAndHeightToWorld.bind(this.renderTools),
      this.renderTools.app); 

    makeShape(this.themes, this.bgshape, shapeData);
  } else {
    makeBoundedBackground(this.data, this.transform.transform.scale, this.bgshape, this.renderTools);
  }
}

TextTransform.prototype.update = function () {
  if (false && this.data.polygon) {
    this.poly = new PIXI.Graphics();
    this.parentContainer.addChild(this.poly);
    this.poly.beginFill(0xff0000);
    for (let i = 0; i < this.data.polygon.length; i++) {
      const points = this.data.polygon.map( ([x,y]) => {
        return new PIXI.Point(this.renderTools.worldToScreen_x(x),this.renderTools.worldToScreen_y(y));
      });
      this.poly.drawPolygon(points);
    }
    this.poly.endFill();
  }
  if (false && this.data.bounded && !this.__setupBounds) {
    this.test = new PIXI.Graphics();
    this.test.beginFill(0x00ffff);
    this.test.scale.x = 1/this.transform.transform.scale.x;
    this.test.scale.y = 1/this.transform.transform.scale.y;
    this.parentContainer.addChild(this.test);
    const {x,y} = this.transform.transform.scale;
    const left = -x/2;
    const right = x/2;
    const top = -y/2;
    const bottom = y/2;
    //const {right,left,top,bottom} = this.data.boundingBox;
    this.test.drawPolygon( [ [left,top], [right,top], [right,bottom], [left, bottom] ].map( ([x,y]) => {
      return new PIXI.Point(
        this.renderTools.worldToScreen_x(x),
        this.renderTools.worldToScreen_y(y)
      )
    }));
    this.test.endFill();
    this.__setupBounds = true;
  }

  if (this.text) {
    this.text.destroy({
      texture:true,
      baseTexture:true
    });
    if (this.hax) {
      this.hax.removeChild(this.text);
    } else {
      this.parentContainer.removeChild(this.text);
    }
  }
  if (this.data.bounded) {
    if (!this.data.__bsetup) {
      this.transform.transform.scale.x = 9;
      this.transform.transform.scale.y = 3;
      this.data.__bsetup = true;
    }

    const boundingBox = {
      left:-this.transform.transform.scale.x/2,
      right:this.transform.transform.scale.x/2,
      top:-this.transform.transform.scale.y/2,
      bottom:this.transform.transform.scale.y/2,
    }

    //this.data.wordWrapWidth = this.renderTools.worldToScreen_x(this.transform.transform.scale.x) * 1.3;
    //this.data.size = Math.min(24,10 * this.data.wordWrapWidth / 300);
    const fontOpts = Object.assign(cloneDeep(this.data), {
      wordWrapWidth: this.renderTools.worldToScreen_x(this.transform.transform.scale.x) * 1.3, 
      size:Math.max(10,this.data.size),
      __format:undefined
      //size:Math.min(24,10 * this.data.wordWrapWidth / 300)
    });
    delete fontOpts.__format;
    if (this.data.editorColor) {
      fontOpts.color = this.data.editorColor;
    }

    const {text,textOptions} = makeFittedText(this.themes,
      this.data.text ? this.data.text : 'enter text.',
      fontOpts,
      boundingBox,
      this.renderTools.convertWidthAndHeightToWorld.bind(this.renderTools),
      this.renderTools,
      false);
    this.text = text;
    if (!this.data.text) {
      this.text.alpha = 0.4;
    } else {
      this.text.alpha = 1;
    }
    this.textOptions = textOptions;
    if (this.data.editorColor) {
      this.textOptions.color = this.data.color;
    }
    this.data.__format = textOptions;

    if (!this.hax) {
      this.hax = new PIXI.Container();
    }
    this.hax.scale.x = 1/this.transform.transform.scale.x / (4/TEXT_UPSCALE);
    this.hax.scale.y = 1/this.transform.transform.scale.y / (4/TEXT_UPSCALE);
    this.text.scale.x *= 1 * (4/TEXT_UPSCALE);
    this.text.scale.y *= 1 * (4/TEXT_UPSCALE);

  } else if (!this.data.polygon) {
    this.textOptions = this.data;
    this.text = makeStyledText(this.themes, this.data.text, this.data);
    // TODO: magic v1 scale values
    if (this.data.v === 2) {
      this.text.scale.x *= 4/TEXT_UPSCALE;
      this.text.scale.y *= 4/TEXT_UPSCALE;
    } else {
      this.text.scale.x *= 3.3;
      this.text.scale.y *= 3.3;
    }
  } else {
    this.text = makeStyledText(this.themes, 'cheese', this.data);
    this.text.scale.x *= 3.3;
    this.text.scale.y *= 3.3;
  }
  //TODO: LOL magic values
  this.text.anchor.x = 0.5;
  this.text.anchor.y = 0.5;

  if (this.data.bg && !this.bgshape) {
    if (this.bgshape) {
      this.parentContainer.removeChild(this.bgshape);
    }
    this.bgshape = new PIXI.Graphics();
    if (this.data.v == 2) {
      if (this.data.bounded) {
        this.bgshape.scale.x = 1/35
        this.bgshape.scale.y = 1/35
      }
    } else {
      this.bgshape.scale.x = 1/35
      this.bgshape.scale.y = 1/35
    }

    this.parentContainer.addChild(this.bgshape);
    this.setupBackground();


  } else {
    if (!this.data.bg && this.bgshape) {
      this.parentContainer.removeChild(this.bgshape);
      this.bgshape = null;
    } else if (this.data.bg) {
      this.setupBackground();
    }
  }

  if (this.hax) {
    this.hax.addChild(this.text);
    this.parentContainer.addChild(this.hax);
  } else {
    this.parentContainer.addChild(this.text);
  }

  if (this.loading) {
    this.renderTools.addToWaitBatch(this.waiting.bind(this));
    this.loading = false;
  } else {
  }
  //this.text.scale.x = 40;
  //this.text.scale.y = 40;
}

TextTransform.prototype.waiting = function () {
  this.events.emit("loaded");
}

TextTransform.prototype.exit = function () {
  //this.editor.removeInteractive(this.myContainer);
  this.parentContainer.removeChild(this.text);
  if (this.text) {
    this.text.destroy({
      texture:true,
      baseTexture:true
    });
  }
}


</script>
